import { css } from 'styled-components';

export const pageMaxWidth = '1280px';

const device = {
  phone: (...args) => css`
    @media (max-width: 1023px) {
      ${css(...args)};
    }
  `,
  mobile: (...args) => css`
    @media (max-width: 1023px) {
      ${css(...args)};
    }
  `,
  desktop: (...args) => css`
    @media (min-width: 1024px) {
      ${css(...args)};
    }
  `,
  largeDesktop: (...args) => css`
    @media (min-width: 1280px) {
      ${css(...args)};
    }
  `,
  all: (...args) => css`
    @media all {
      ${css(...args)};
    }
  `,
};

const sizes = [320, 360, 375, 412, 414, 568, 640, 667, 684, 732, 736, 768, 1024, 1366];
export const media = sizes.reduce((acc, pxSize) => {
  acc[`max-${pxSize}`] = (...args) => css`
    @media (max-width: ${pxSize}px) {
      ${css(...args)};
    }
  `;
  acc[`min-${pxSize}`] = (...args) => css`
    @media (min-width: ${pxSize}px) {
      ${css(...args)};
    }
  `;
  acc[`max-landscape-${pxSize}`] = (...args) => css`
    @media (max-width: ${pxSize}px) and (orientation: landscape) {
      ${css(...args)};
    }
  `;
  acc[`min-landscape-${pxSize}`] = (...args) => css`
    @media (min-width: ${pxSize}px) and (orientation: landscape) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});

export default device;
